import { makeEntity } from "./_base";

// CITIDAN transactions use `created_at`; Base44 screens expect `date`. Normalize on read
// so date-fns format() never receives an invalid value.
const base = makeEntity("/transactions");

function normalize(t) {
  if (!t || typeof t !== "object") return t;
  return { ...t, date: t.date || t.created_at || t.timestamp || null };
}

export const Transaction = {
  ...base,
  async list() {
    return (await base.list()).map(normalize);
  },
  async filter(query) {
    return (await base.filter(query)).map(normalize);
  },
  async get(id) {
    return normalize(await base.get(id));
  },
};
